(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-video-product-carousel]';

    const initialize = (root) => {
      if (!root || root.dataset.carouselInitialized === 'true') return;
      root.dataset.carouselInitialized = 'true';

      const track = root.querySelector('[data-carousel-track]');
      const cards = Array.from(root.querySelectorAll('[data-carousel-card]'));
      const previous = root.querySelector('[data-carousel-previous]');
      const next = root.querySelector('[data-carousel-next]');
      const current = root.querySelector('[data-carousel-current]');
      const progress = root.querySelector('[data-carousel-progress]');
      if (!track || cards.length === 0) return;

      const pauseCard = (card) => {
        const video = card.querySelector('video');
        const button = card.querySelector('[data-video-toggle]');
        if (video) video.pause();
        card.classList.remove('is-playing');
        if (button) button.setAttribute('aria-label', button.dataset.playLabel);
      };

      cards.forEach((card) => {
        const video = card.querySelector('video');
        const button = card.querySelector('[data-video-toggle]');
        if (!video || !button) return;

        button.dataset.playLabel = button.getAttribute('aria-label');
        button.dataset.pauseLabel = root.dataset.pauseLabel || button.dataset.playLabel;
      });

      track.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return;
        const button = event.target.closest('[data-video-toggle]');
        const card = button?.closest('[data-carousel-card]');
        const video = card?.querySelector('video');
        if (!button || !card || !video) return;

        if (video.paused) {
          cards.forEach((item) => {
            if (item !== card) pauseCard(item);
          });
          video.play().then(() => {
            card.classList.add('is-playing');
            button.setAttribute('aria-label', button.dataset.pauseLabel);
          }).catch(() => pauseCard(card));
        } else {
          pauseCard(card);
        }
      });

      track.addEventListener('ended', (event) => {
        if (!(event.target instanceof HTMLVideoElement)) return;
        const card = event.target.closest('[data-carousel-card]');
        if (card) pauseCard(card);
      }, true);

      const closestIndex = () => {
        const first = cards[0];
        const second = cards[1];
        const step = second
          ? Math.abs(second.offsetLeft - first.offsetLeft)
          : first.offsetWidth;
        if (!step) return 0;
        return Math.max(0, Math.min(cards.length - 1, Math.round(Math.abs(track.scrollLeft) / step)));
      };

      const update = () => {
        const index = closestIndex();
        if (current) current.textContent = String(index + 1);
        if (progress) progress.style.width = `${((index + 1) / cards.length) * 100}%`;
        if (previous) previous.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };

      const scrollToIndex = (index) => {
        cards[Math.max(0, Math.min(index, cards.length - 1))]?.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'start'
        });
      };

      let updateFrame = 0;
      const requestUpdate = () => {
        if (updateFrame) return;
        updateFrame = window.requestAnimationFrame(() => {
          updateFrame = 0;
          update();
        });
      };

      previous?.addEventListener('click', () => scrollToIndex(closestIndex() - 1));
      next?.addEventListener('click', () => scrollToIndex(closestIndex() + 1));
      track.addEventListener('scroll', requestUpdate, { passive: true });
      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          scrollToIndex(closestIndex() - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          scrollToIndex(closestIndex() + 1);
        }
      });
      update();
    };

    const lazyObserver = !window.Shopify?.designMode && 'IntersectionObserver' in window
      ? new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            initialize(entry.target);
          });
        }, { rootMargin: '800px 0px' })
      : null;

    const initializeAll = (scope = document) => {
      scope.querySelectorAll(selector).forEach((root) => {
        if (lazyObserver) lazyObserver.observe(root);
        else initialize(root);
      });
    };

    initializeAll();

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const card = event.target.closest('[data-carousel-card]');
      if (!card) return;
      const root = card.closest(selector);
      if (root) initialize(root);
      card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
